export default __webpack_public_path__ + "static/media/Coping Mechanisms - Anger worksheet.bb61c7b1.pdf";